/* global axios */
import ApiClient from '../ApiClient';

class DinastiaWhatsappChannel extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  getUrl(inboxId, action) {
    return `${this.baseUrl()}/inboxes/${inboxId}/dinastia_whatsapp/${action}`;
  }

  react(inboxId, { messageId, emoji }) {
    return axios.post(this.getUrl(inboxId, 'react'), {
      message_id: messageId,
      emoji,
    });
  }

  editMessage(inboxId, { messageId, content }) {
    return axios.post(this.getUrl(inboxId, 'edit_message'), {
      message_id: messageId,
      content,
    });
  }

  deleteMessage(inboxId, { messageId }) {
    return axios.post(this.getUrl(inboxId, 'delete_message'), {
      message_id: messageId,
    });
  }

  markRead(inboxId, { messageId }) {
    return axios.post(this.getUrl(inboxId, 'mark_read'), {
      message_id: messageId,
    });
  }

  sendTyping(inboxId, { to, duration }) {
    return axios.post(this.getUrl(inboxId, 'typing'), {
      to,
      duration: duration || 3000,
    });
  }

  getQrCode(inboxId) {
    return axios.get(this.getUrl(inboxId, 'qr_code'));
  }

  connect(inboxId) {
    return axios.post(this.getUrl(inboxId, 'connect'));
  }

  disconnect(inboxId) {
    return axios.post(this.getUrl(inboxId, 'disconnect'));
  }

  refresh(inboxId) {
    return axios.post(this.getUrl(inboxId, 'refresh'));
  }

  syncHistory(inboxId) {
    return axios.post(this.getUrl(inboxId, 'history_sync'));
  }

  getSessionStatus(inboxId) {
    return axios.get(this.getUrl(inboxId, 'session_status'));
  }

  toggleGroups(inboxId, enabled) {
    return axios.post(this.getUrl(inboxId, 'toggle_groups'), { enabled });
  }

  getGroups(inboxId) {
    return axios.get(this.getUrl(inboxId, 'groups'));
  }

  getGroupInfo(inboxId, groupJid) {
    return axios.post(this.getUrl(inboxId, 'group_info'), {
      group_jid: groupJid,
    });
  }

  getGroupParticipants(inboxId, groupJid) {
    return axios.post(this.getUrl(inboxId, 'group_participants'), {
      group_jid: groupJid,
    });
  }

  getGroupInviteLink(inboxId, groupJid) {
    return axios.post(this.getUrl(inboxId, 'group_invite_link'), {
      group_jid: groupJid,
    });
  }

  addGroupParticipant(inboxId, groupJid, phones) {
    return axios.post(this.getUrl(inboxId, 'group_add_participant'), {
      group_jid: groupJid,
      phones,
    });
  }

  removeGroupParticipant(inboxId, groupJid, phones) {
    return axios.post(this.getUrl(inboxId, 'group_remove_participant'), {
      group_jid: groupJid,
      phones,
    });
  }

  setGroupName(inboxId, groupJid, name) {
    return axios.post(this.getUrl(inboxId, 'group_set_name'), {
      group_jid: groupJid,
      name,
    });
  }

  setGroupTopic(inboxId, groupJid, topic) {
    return axios.post(this.getUrl(inboxId, 'group_set_topic'), {
      group_jid: groupJid,
      topic,
    });
  }

  createGroup(inboxId, name, phones) {
    return axios.post(this.getUrl(inboxId, 'group_create'), {
      name,
      phones,
    });
  }

  getProxyInfo(inboxId) {
    return axios.get(this.getUrl(inboxId, 'proxy_info'));
  }

  setManualProxy(inboxId, proxyUrl) {
    return axios.post(this.getUrl(inboxId, 'set_manual_proxy'), {
      proxy_url: proxyUrl,
    });
  }

  getSettings(inboxId) {
    return axios.get(this.getUrl(inboxId, 'settings'));
  }

  toggleFlag(inboxId, flag, value) {
    return axios.post(this.getUrl(inboxId, 'toggle_flag'), { flag, value });
  }

  syncEvents(inboxId) {
    return axios.post(this.getUrl(inboxId, 'sync_events'));
  }

  toggleAutoReconnect(inboxId, enabled) {
    return axios.post(this.getUrl(inboxId, 'toggle_auto_reconnect'), {
      enabled,
    });
  }
}

export default new DinastiaWhatsappChannel();
